import React from "react";
import { withTranslation } from "react-i18next";
import { Marker } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import L from "leaflet";
import { createSibicModal } from './SibicModal'
import { createEasinModal } from './EasinModal'
import { shallowEqual } from "./Utils";
import { HOST, API_URL } from '../auxiliar/constants'
import '../css/ficha_int.css'

var { EventEmitter } = require('fbemitter')

export const ClusterEmitter = new EventEmitter()

const greenIcon = new L.Icon({
    iconUrl:
        "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
    shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const blueIcon = new L.Icon({
    iconUrl:
        "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png",
    shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

class ClusterGroup extends React.Component {

    emitter

    state = {
        sibicFilters: null,
        easinFilters: null
    }

    applyFilters = (sibicIds, easinIds) => {


        if (sibicIds === null) {
            this.cluster.leafletElement.eachLayer((layer) => {
                if(layer.options.type === "SIBIC") {
                    layer.setOpacity(1)
                }
            })
        }

        if (easinIds === null) {
            this.cluster.leafletElement.eachLayer((layer) => {
                if(layer.options.type === "EASIN") {
                    layer.setOpacity(1)
                }
            })
        }

        if (sibicIds !== null && sibicIds.length === 0) {
            this.cluster.leafletElement.eachLayer((layer) => {
                if(layer.options.type === "SIBIC") {
                    layer.setOpacity(0)
                }
            })
        }

        if (easinIds !== null && easinIds.length === 0) {
            this.cluster.leafletElement.eachLayer((layer) => {
                if(layer.options.type === "EASIN") {
                    layer.setOpacity(0)
                }
            })
        }

        if (sibicIds !== null && sibicIds.length > 0) {
            this.cluster.leafletElement.eachLayer((layer) => {
                if (layer.options.type === "SIBIC") {
                    if (sibicIds.indexOf(layer.options.id) === -1) {
                        layer.setOpacity(0)
                    } else {
                        layer.setOpacity(1)
                    }
                }
            })
        }

        if (easinIds !== null && easinIds.length > 0) {
            this.cluster.leafletElement.eachLayer((layer) => {
                if (layer.options.type === "EASIN") {
                    if (easinIds.indexOf(layer.options.id) === -1) {
                        layer.setOpacity(0)
                    } else {
                        layer.setOpacity(1)
                    }
                }
            })
        }

        this.cluster.leafletElement.refreshClusters()
    }

    componentDidMount() {
        this.emitter = ClusterEmitter.addListener('apply-filters', this.applyFilters);
    }

    componentWillUnmount() {
        this.emitter.remove();
    }

    async renderEasinPopup(event, id) {
        if(event.target.options.opacity === 0 || event.target.options.opacity === '0') {
            return
        }

        if (event.target._popup) {
            event.target.setPopupContent(createEasinModal(event.target.options['recordBU']))
            setTimeout(() => event.target.openPopup())
        } else {
            await fetch(`${HOST}${API_URL}/?function=getRecordCard&rec=${id}`)
                .then(response => response.json())
                .then(data => {
                    if (data.length > 0) {
                        event.target.bindPopup(createEasinModal(data[0])).openPopup()
                        event.target.options['recordBU'] = data[0]
                    }
                })
        }
    }

    async renderSibicPopup(event, id) {
        if(event.target.options.opacity === 0 || event.target.options.opacity === '0') {
            return
        }

        if (event.target._popup) {
            event.target.setPopupContent(createSibicModal(event.target.options['recordBU']))
            setTimeout(() => event.target.openPopup())
        } else {
            await fetch(`https://eei.sibic.org/API/geo4.php?recordId=${id}`)
                .then(response => response.json())
                .then(data => {
                    if (data.records.length > 0) {
                        event.target.bindPopup(createSibicModal(data.records[0])).openPopup()
                        event.target.options['recordBU'] = data.records[0]
                    }
                })
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!shallowEqual(this.state, nextState)) {
            return true;
        }
        if (this.props.sibicRecords.length !== nextProps.sibicRecords.length) {
            return true;
        } else if (this.props.easinRecords.length !== nextProps.easinRecords.length) {
            return true;
        }
        return false;
    }


    getMarkers = () => {
        let markers = []

        this.props.sibicRecords.forEach(( r, i )=> {
            if ((this.state.sibicFilters === null) || this.state.sibicFilters.indexOf(r.specId) !== -1) {
                markers.push(<Marker type={'SIBIC'} id={r.specId} icon={blueIcon} position={[r.lat, r.lng]} key={r.recId} onClick={(e) => this.renderSibicPopup(e, r.recId)}/>)
            }
        })
        this.props.easinRecords.forEach(( r, i )=> {
            if ((this.state.easinFilters === null) || this.state.easinFilters.indexOf(r.specId) !== -1) {
                markers.push(<Marker type={'EASIN'} id={r.specId} icon={greenIcon} position={[r.lat, r.lng]} key={r.recId} onClick={(e) => this.renderEasinPopup(e, r.recId)} />)
            }
        })

        return markers
    }


    getClusterIcon = (cluster) => {

        var markers = cluster.getAllChildMarkers();

        let visibleCount = 0

        for (let i = 0; i < markers.length; i++) {

          if (markers[i].options.opacity === 1  || markers[i].options.opacity === '1') {
              visibleCount++
          }
        }

        var c = ' marker-cluster-';
		if (visibleCount < 10) {
			c += 'small';
		} else if (visibleCount < 100) {
			c += 'medium';
		} else {
			c += 'large';
		}


        return visibleCount === 0 ? new L.DivIcon({ html: '<span/>', className: 'hidden-div-icon' }) : new L.DivIcon({ html: '<div><span>' + visibleCount + '</span></div>', className: 'marker-cluster' + c, iconSize: new L.Point(40, 40) });
    }

    handleClusterClick = (a) => {
           let visibleCount = 0
           let hiddenCount = 0
           let childs = a.layer.getAllChildMarkers()

           childs.forEach(m => {
               if (m.options.opacity === 1  || m.options.opacity === '1') {
                   visibleCount++
               } else {
                   hiddenCount++
               }
           })

           if(visibleCount === 1 && hiddenCount > 0) {
               //solo uno visible y alguno ( > 0 ) oculto
             document.querySelectorAll('path.leaflet-interactive').forEach(e => e.parentNode.removeChild(e))
             setTimeout(() => document.querySelectorAll('path.leaflet-interactive').forEach(e => e.parentNode.removeChild(e)),10)
             setTimeout(() => document.querySelectorAll('path.leaflet-interactive').forEach(e => e.parentNode.removeChild(e)),10)
             setTimeout(() => document.querySelectorAll('path.leaflet-interactive').forEach(e => e.parentNode.removeChild(e)),10)
             setTimeout(() => document.querySelectorAll('path.leaflet-interactive').forEach(e => e.parentNode.removeChild(e)),30)

           }

    }

    render() {

        if (this.props.sibicRecords.length === 0 && this.props.easinRecords.length === 0) return null;

        let markers = this.getMarkers()

        return (
            <MarkerClusterGroup
                ref={(ref) => { this.cluster = ref }}
                showCoverageOnHover={false}
                iconCreateFunction={(cluster) => this.getClusterIcon(cluster)}
                onClusterClick={this.handleClusterClick}
                >
                {markers}
            </MarkerClusterGroup>
        );
    }
}

export default withTranslation()(ClusterGroup);
